import { useEffect, useRef, useState } from "react";
import { AutoSizer } from "react-virtualized";
import { VIDEOS_PANEL_STOCK_MASONRY_GAPS } from "../../constants";
import { useStockStoreShallow } from "../../store";
import { StockMasonryColumn } from "./stock-masonry-column";

interface IProps {
  searchQuery: string;

  loadMoreVideos: () => void;
}

export const StockMasonry = ({ searchQuery, loadMoreVideos }: IProps) => {
  const columnsData = useStockStoreShallow((s) => s.columnsData);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const containerEl = containerRef.current;
    if (!containerEl) return;
  }, [searchQuery]);

  return (
    <div
      ref={containerRef}
      className="scrollbar tw-mt-3 tw-size-full tw-w-[calc(100%-6px)] tw-overflow-y-scroll tw-overscroll-contain tw-pl-6 tw-pr-3 tw-pt-1"
      onScroll={(e) => {
        setScrollTop(e.currentTarget.scrollTop);
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <div className="tw-flex tw-space-x-2" style={{ width }}>
            {columnsData.map((col, colIdx) => (
              <StockMasonryColumn
                key={colIdx}
                onLoadMore={colIdx === 0 ? loadMoreVideos : undefined}
                colIdx={colIdx}
                videos={col}
                scrollTop={scrollTop}
                colWidth={
                  (width -
                    VIDEOS_PANEL_STOCK_MASONRY_GAPS *
                      (columnsData.length - 1)) /
                  columnsData.length
                }
                height={height}
              />
            ))}
          </div>
        )}
      </AutoSizer>
    </div>
  );
};
